import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoashtavinayakcabs() {



  const cardData = {




keyword: "Pune to Ashtavinayak Cabs",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Ashtavinayak Cab Service for devotees, families, senior citizens, couples, and groups planning a spiritual journey across Maharashtra. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for one-day, multi-day, one-way, round-trip, and customized Ashtavinayak Darshan itineraries. With experienced drivers, clean and well-maintained vehicles, flexible pickup locations, spacious luggage facilities, transparent pricing, and 24/7 customer assistance, we make temple travel convenient and peaceful. Six of the eight traditional Ashtavinayak temples are located in Pune district, while the complete circuit also includes temples in Raigad and Ahmednagar districts. :contentReference[oaicite:1]{index=1}",

topPlaces: [
  {
    title: "Morgaon",
    description: "Morgaon is home to the famous Moreshwar Temple, one of the principal destinations in the Ashtavinayak pilgrimage circuit. The temple is located in a peaceful rural setting and holds great religious importance for devotees of Lord Ganesha. Travelers booking a Pune to Ashtavinayak cab can conveniently begin or include Morgaon in their customized Darshan itinerary."
  },
  {
    title: "Theur",
    description: "Theur is known for the historic Chintamani Temple, an important Ashtavinayak shrine dedicated to Lord Ganesha. Its location near Pune makes it a convenient temple stop for families and devotees planning a religious road journey. Garud Cab Service provides comfortable vehicles for devotees who want flexible temple timings and convenient door-to-door transportation."
  },
  {
    title: "Ranjangaon",
    description: "Ranjangaon is home to the Mahaganapati Temple, one of the revered Ashtavinayak temples of Maharashtra. The shrine is an important spiritual destination for devotees traveling through the Pune region. A private cab allows families and groups to visit Ranjangaon comfortably while continuing toward other temples on their personalized Ashtavinayak route."
  },
  {
    title: "Ozar",
    description: "Ozar is famous for the Vighneshwar Temple, one of the sacred Ashtavinayak temples and an important stop on the traditional pilgrimage route. The temple is surrounded by a peaceful atmosphere and attracts devotees throughout the year. Travelers can book a chauffeur-driven cab from Pune for convenient Darshan and onward travel to nearby pilgrimage destinations."
  },
  {
    title: "Lenyadri",
    description: "Lenyadri is home to the Girijatmaj Ashtavinayak Temple, located within an ancient rock-cut cave complex near Junnar. Visitors need to climb a series of steps to reach the shrine, while the surrounding hills provide beautiful natural scenery. :contentReference[oaicite:2]{index=2} A spacious cab is useful for families and groups traveling from Pune with senior citizens and luggage."
  },
  {
    title: "Siddhatek",
    description: "Siddhatek is known for the Siddhivinayak Temple situated near the Bhima River and is one of the revered Ashtavinayak pilgrimage destinations. The temple offers a peaceful spiritual setting surrounded by rural landscapes. :contentReference[oaicite:3]{index=3} Garud Cab Service provides comfortable transportation for devotees traveling from Pune as part of a one-day or multi-day Darshan journey."
  },
  {
    title: "Pali",
    description: "Pali is home to the Ballaleshwar Temple, one of the eight Ashtavinayak temples dedicated to Lord Ganesha. The temple has distinctive religious and architectural significance and attracts devotees from different parts of Maharashtra. :contentReference[oaicite:4]{index=4} Travelers from Pune can choose a private cab for a comfortable journey to Pali and combine it with other nearby pilgrimage destinations."
  },
  {
    title: "Mahad",
    description: "Mahad is the location of the Varadvinayak Temple, one of the eight Ashtavinayak shrines in Maharashtra. The temple is known for its peaceful surroundings and spiritual significance, making it an important stop for devotees completing the pilgrimage circuit. :contentReference[oaicite:5]{index=5} Garud Cab Service offers flexible cab arrangements for families and groups traveling from Pune to Mahad."
  },
  {
    title: "Junnar",
    description: "Junnar is an important pilgrimage and heritage region associated with the Lenyadri Ashtavinayak Temple and several historic attractions. The surrounding Sahyadri landscape makes the journey especially scenic, while the region offers opportunities to combine religious travel with heritage sightseeing. Travelers can use a comfortable private cab to explore Junnar and nearby temple destinations."
  },
  {
    title: "Rajgurunagar",
    description: "Rajgurunagar is a historic town in the Pune region and a convenient travel point for devotees heading toward the Junnar and Lenyadri side of the Ashtavinayak circuit. Its location makes it useful when planning a multi-stop temple journey from Pune. Garud Cab Service can provide spacious chauffeur-driven vehicles for families and groups traveling through this route."
  }
],



"services": [
{
"name": "Ashtavinayak Darshan Cab Pune",
"description": "Book Ashtavinayak Darshan Cab Pune for a comfortable and convenient pilgrimage journey covering the famous Ashtavinayak temples with a professional chauffeur and well-maintained AC vehicle. Choose Sedan, Ertiga, Innova, Innova Crysta, SUV, or Tempo Traveller options for family groups, senior passengers, devotees, and customized darshan trips from Pune."
},
{
"name": "Car Rental for Ashtavinayak from Pune",
"description": "Choose Car Rental for Ashtavinayak from Pune for a private and comfortable temple tour with an experienced chauffeur. Travel conveniently between the Ashtavinayak temples in a spacious AC vehicle with flexible pickup, sightseeing, darshan, halt, and return arrangements suitable for families and groups."
},
{
"name": "Cost of Ashtavinayak Yatra Tour by Car from Pune",
"description": "Get information about the Cost of Ashtavinayak Yatra Tour by Car from Pune according to your vehicle type, travel duration, itinerary, passenger count, and journey requirements. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller options for comfortable one-day, two-day, or customized pilgrimage travel."
},
{
"name": "Pune to Ashtavinayak Cabs",
"description": "Book Pune to Ashtavinayak Cabs for a comfortable pilgrimage tour covering the Ashtavinayak temples with professional chauffeurs, clean AC vehicles, spacious seating, and convenient pickup arrangements. The service is suitable for families, senior citizens, devotees, small groups, and travelers planning customized temple visits."
},
{
"name": "Pune to Ashtavinayak Cab Service",
"description": "Choose Pune to Ashtavinayak Cab Service for dependable chauffeur-driven transportation throughout your Ashtavinayak pilgrimage. Enjoy comfortable AC travel, flexible temple visit schedules, convenient pickup and drop facilities, and vehicle choices suitable for individuals, families, senior passengers, and groups."
},
{
"name": "Pune to Ashtavinayak Taxi",
"description": "Reserve Pune to Ashtavinayak Taxi for a private and comfortable temple journey with experienced drivers and spacious air-conditioned vehicles. The service is suitable for devotees planning Ashtavinayak darshan, family pilgrimage trips, senior citizen travel, one-day tours, multi-day journeys, and customized temple itineraries."
},
{
"name": "Pune to Ashtavinayak Taxi Service",
"description": "Book Pune to Ashtavinayak Taxi Service for reliable transportation between Pune and the Ashtavinayak temples with professional chauffeurs and well-maintained AC vehicles. Flexible travel arrangements can be planned according to your darshan schedule, temple sequence, passenger count, luggage, and preferred vehicle."
},
{
"name": "Cab from Pune to Ashtavinayak",
"description": "Hire a Cab from Pune to Ashtavinayak for a comfortable and private pilgrimage journey with convenient pickup from your home, office, hotel, or preferred location. Travel in a clean AC vehicle with an experienced chauffeur and enjoy flexible arrangements for temple visits, sightseeing, halts, and return travel."
},
{
"name": "Taxi from Pune to Ashtavinayak",
"description": "Choose Taxi from Pune to Ashtavinayak for convenient chauffeur-driven transportation during your temple tour. The service provides private AC travel, spacious seating, flexible pickup, and suitable vehicle options for families, devotees, senior passengers, and groups planning one-day or multi-day Ashtavinayak darshan."
},
{
"name": "Pune to Ashtavinayak Car Rental",
"description": "Book Pune to Ashtavinayak Car Rental with a professional chauffeur for a comfortable and stress-free pilgrimage journey. Choose a suitable Sedan, Ertiga, Innova, Innova Crysta, SUV, or Tempo Traveller according to your group size, luggage requirements, travel duration, temple itinerary, and comfort preferences."
},
{
"name": "Pune to Ashtavinayak Cab Booking",
"description": "Make Pune to Ashtavinayak Cab Booking for a scheduled private temple tour with convenient pickup and return arrangements. Select your preferred travel date, vehicle, passenger capacity, and itinerary while enjoying professional chauffeur service, comfortable AC transportation, and flexible darshan travel arrangements."
},
{
"name": "Pune to Ashtavinayak Taxi Booking Online",
"description": "Use Pune to Ashtavinayak Taxi Booking Online to arrange your pilgrimage transportation in advance. Select your pickup location, travel date, group size, vehicle category, and preferred journey duration while enjoying private AC transportation and professional chauffeur service for a convenient Ashtavinayak temple tour."
},
{
"name": "Pune to Ashtavinayak Cab Fare",
"description": "Get Pune to Ashtavinayak Cab Fare information according to your selected vehicle, travel duration, passenger count, and pilgrimage itinerary. Choose economical Sedan options or spacious Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller vehicles for comfortable temple travel and return transportation."
},
{
"name": "Pune to Ashtavinayak Taxi Charges",
"description": "Check Pune to Ashtavinayak Taxi Charges based on vehicle category, journey duration, temple itinerary, and travel requirements. Select a comfortable AC Sedan, Ertiga, Innova, Innova Crysta, SUV, or Tempo Traveller for families, groups, devotees, and senior passengers planning an organized pilgrimage."
},
{
"name": "Pune to Ashtavinayak Cab Price",
"description": "Find a suitable Pune to Ashtavinayak Cab Price with multiple vehicle categories available for different group sizes and pilgrimage requirements. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller options for one-day, two-day, multi-day, or customized Ashtavinayak darshan tours."
},
{
"name": "Best Pune to Ashtavinayak Cab Service",
"description": "Book the Best Pune to Ashtavinayak Cab Service for dependable pilgrimage transportation with experienced chauffeurs, clean AC vehicles, comfortable seating, and flexible temple tour arrangements. Vehicle options are available for families, senior citizens, devotees, corporate groups, and larger parties requiring private temple travel."
},
{
"name": "Cheap Pune to Ashtavinayak Cab",
"description": "Choose a Cheap Pune to Ashtavinayak Cab for budget-friendly pilgrimage transportation while maintaining essential comfort and convenience. Affordable Sedan, Ertiga, and other vehicle options are available for devotees, families, students, senior passengers, and groups planning one-day or multi-day Ashtavinayak temple tours."
},
{
"name": "Pune to Ashtavinayak One Day Cab",
"description": "Book Pune to Ashtavinayak One Day Cab for a planned same-day pilgrimage journey with convenient temple visits and return travel. Enjoy an experienced chauffeur, comfortable AC vehicle, flexible pickup, and suitable arrangements for families and devotees who want to complete their planned Ashtavinayak darshan within a single day."
},
{
"name": "Pune to Ashtavinayak Two Day Cab",
"description": "Reserve Pune to Ashtavinayak Two Day Cab for a more relaxed pilgrimage itinerary with comfortable travel between temples and sufficient time for darshan and scheduled halts. Choose a spacious AC vehicle with professional chauffeur service for families, senior citizens, devotees, and groups planning an overnight temple tour."
},
{
"name": "Pune to Ashtavinayak Outstation Cab",
"description": "Choose Pune to Ashtavinayak Outstation Cab for dependable long-distance pilgrimage transportation with professional chauffeurs and comfortable AC vehicles. The service can be arranged for one-day, two-day, multi-day, one-way, or customized temple journeys according to your itinerary, passenger count, luggage, and travel requirements."
},
{
"name": "Pune to Ashtavinayak Innova Cab",
"description": "Book Pune to Ashtavinayak Innova Cab for spacious and comfortable family pilgrimage travel with air conditioning, practical luggage capacity, and professional chauffeur service. Innova is suitable for devotees, families, senior passengers, and small groups planning temple visits with convenient pickup and return arrangements."
},
{
"name": "Pune to Ashtavinayak Ertiga Cab",
"description": "Reserve Pune to Ashtavinayak Ertiga Cab for practical and comfortable pilgrimage transportation with spacious seating, AC interiors, luggage capacity, and an experienced chauffeur. Ertiga is a convenient choice for families and small groups planning one-day, two-day, or customized Ashtavinayak darshan trips."
},
{
"name": "Pune to Ashtavinayak Sedan Cab",
"description": "Choose Pune to Ashtavinayak Sedan Cab for economical and comfortable private pilgrimage travel with a professional chauffeur and clean AC interiors. The sedan is suitable for small families, couples, individual devotees, and travelers looking for a convenient vehicle for planned Ashtavinayak temple visits."
},
{
"name": "Pune to Ashtavinayak SUV Taxi",
"description": "Book Pune to Ashtavinayak SUV Taxi for spacious and comfortable pilgrimage travel with premium seating, air conditioning, luggage capacity, and professional chauffeur service. SUV transportation is suitable for families and groups seeking additional space and comfort during longer temple journeys."
},
{
"name": "Pune to Ashtavinayak AC Cab",
"description": "Reserve Pune to Ashtavinayak AC Cab for comfortable temple travel in a clean and well-maintained air-conditioned vehicle. Enjoy professional chauffeur service, convenient pickup and drop facilities, flexible temple visit arrangements, and suitable vehicle options for devotees, families, senior citizens, and groups."
},
{
"name": "Pune to Ashtavinayak Tempo Traveller",
"description": "Book Pune to Ashtavinayak Tempo Traveller for group pilgrimage travel with spacious seating and comfortable AC transportation. It is suitable for larger families, devotional groups, senior citizens, and friends traveling together for one-day, two-day, or customized Ashtavinayak temple tours with convenient group pickup."
},
{
"name": "Pune Airport to Ashtavinayak Cab",
"description": "Choose Pune Airport to Ashtavinayak Cab for convenient airport pickup followed by a private pilgrimage journey to the Ashtavinayak temples. Professional chauffeurs provide comfortable AC transportation with luggage-friendly vehicles, making the service suitable for families, devotees, tourists, and passengers arriving at Pune Airport."
},
{
"name": "Hinjewadi to Ashtavinayak Taxi",
"description": "Book Hinjewadi to Ashtavinayak Taxi for comfortable pilgrimage transportation from Hinjewadi with convenient pickup and professional chauffeur service. Enjoy clean AC vehicles and flexible temple tour arrangements suitable for families, devotees, senior passengers, corporate groups, and travelers planning one-day or multi-day darshan."
},
{
"name": "Wakad to Ashtavinayak Cab",
"description": "Reserve Wakad to Ashtavinayak Cab for a convenient and private temple journey with professional chauffeurs and comfortable AC vehicles. Flexible pickup from Wakad and customized travel arrangements make the service suitable for families, devotees, senior citizens, and groups planning Ashtavinayak darshan."
},
{
"name": "Hadapsar to Ashtavinayak Taxi",
"description": "Choose Hadapsar to Ashtavinayak Taxi for reliable pilgrimage transportation with comfortable AC vehicles, experienced chauffeurs, and convenient pickup arrangements. The service can be planned according to your temple sequence, travel duration, passenger count, luggage requirements, and preferred one-day or multi-day itinerary."
},
{
"name": "Pimpri Chinchwad to Ashtavinayak Cab",
"description": "Book Pimpri Chinchwad to Ashtavinayak Cab for comfortable group and family transportation during your pilgrimage journey. Enjoy spacious AC vehicles, professional chauffeur service, flexible pickup, temple visit arrangements, and suitable vehicle choices for devotees, senior passengers, families, and groups."
},
{
"name": "Pune to Ashtavinayak Cab Near Me",
"description": "Find Pune to Ashtavinayak Cab Near Me for convenient pilgrimage transportation from your preferred pickup location in Pune. Enjoy flexible booking, professional chauffeur service, comfortable AC vehicles, and suitable Sedan, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller options for your Ashtavinayak darshan."
}
],
"tableData": [
["Ashtavinayak Darshan Cab Pune", "Car Rental for Ashtavinayak from Pune"],
["Cost of Ashtavinayak Yatra Tour by Car from Pune", "Pune to Ashtavinayak Cabs"],
["Pune to Ashtavinayak Cab Service", "Pune to Ashtavinayak Taxi"],
["Pune to Ashtavinayak Taxi Service", "Cab from Pune to Ashtavinayak"],
["Taxi from Pune to Ashtavinayak", "Pune to Ashtavinayak Car Rental"],
["Pune to Ashtavinayak Cab Booking", "Pune to Ashtavinayak Taxi Booking Online"],
["Pune to Ashtavinayak Cab Fare", "Pune to Ashtavinayak Taxi Charges"],
["Pune to Ashtavinayak Cab Price", "Best Pune to Ashtavinayak Cab Service"],
["Cheap Pune to Ashtavinayak Cab", "Pune to Ashtavinayak One Day Cab"],
["Pune to Ashtavinayak Two Day Cab", "Pune to Ashtavinayak Outstation Cab"],
["Pune to Ashtavinayak Innova Cab", "Pune to Ashtavinayak Ertiga Cab"],
["Pune to Ashtavinayak Sedan Cab", "Pune to Ashtavinayak SUV Taxi"],
["Pune to Ashtavinayak AC Cab", "Pune to Ashtavinayak Tempo Traveller"],
["Pune Airport to Ashtavinayak Cab", "Hinjewadi to Ashtavinayak Taxi"],
["Wakad to Ashtavinayak Cab", "Hadapsar to Ashtavinayak Taxi"],
["Pimpri Chinchwad to Ashtavinayak Cab", "Pune to Ashtavinayak Cab Near Me"]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Ashtavinayak Cabs for Temple Tours",
    WhyChoosedescription: "Garud Cab Service provides private cabs from Pune for devotees planning an Ashtavinayak pilgrimage, offering convenient transportation for families, senior citizens, couples, and groups visiting the eight revered Ganpati temples."
  },
  {
    WhyChooseheading: "Complete Pilgrimage Travel from Pune",
    WhyChoosedescription: "A dedicated cab makes it easier to cover multiple temple destinations during the pilgrimage without arranging separate local transportation between different locations."
  },
  {
    WhyChooseheading: "Customizable Temple Route",
    WhyChoosedescription: "Plan your Ashtavinayak journey according to your preferred dates, temple sequence, overnight stays, darshan schedule, meal breaks, and return requirements with a flexible private travel arrangement."
  },
  {
    WhyChooseheading: "Comfortable Choice for Senior Devotees",
    WhyChoosedescription: "Families travelling with elderly devotees can benefit from private transportation, allowing convenient rest stops and a more relaxed journey between the different pilgrimage locations."
  },
  {
    WhyChooseheading: "Vehicles for Families & Pilgrimage Groups",
    WhyChoosedescription: "Choose a suitable vehicle based on the number of devotees, luggage, and comfort requirements. Garud Cab Service can arrange options for couples, families, and larger travelling groups."
  },
  {
    WhyChooseheading: "Useful for Multi-Day Darshan Plans",
    WhyChoosedescription: "The Ashtavinayak circuit may require several days depending on the itinerary. A private cab provides greater flexibility for managing travel time, temple visits, accommodation stops, and sightseeing."
  },
  {
    WhyChooseheading: "Convenient Pune Pickup & Drop",
    WhyChoosedescription: "Begin your pilgrimage from your home, hotel, office, residential area, or another preferred location in Pune and arrange the return journey according to your selected pilgrimage plan."
  },
  {
    WhyChooseheading: "Plan Your Ashtavinayak Yatra with Garud",
    WhyChoosedescription: "Share your travel dates, number of devotees, Pune pickup point, preferred vehicle, and pilgrimage itinerary with Garud Cab Service to arrange suitable transportation for your Ashtavinayak tour."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Ashtavinayak Cabs?",
    answer: "Yes, Garud Cab Service provides private cab arrangements from Pune for devotees planning Ashtavinayak temple tours and pilgrimage journeys."
  },
  {
    question: "Can I book a cab for the complete Ashtavinayak Yatra?",
    answer: "Yes, you can discuss a multi-destination cab arrangement covering the Ashtavinayak pilgrimage according to your preferred route and travel schedule."
  },
  {
    question: "Is the Ashtavinayak cab suitable for senior citizens?",
    answer: "Yes, private cab travel can be a convenient option for senior citizens because the journey can include planned breaks and a flexible travel schedule."
  },
  {
    question: "Can families book a private cab for Ashtavinayak Darshan?",
    answer: "Yes, families can book a suitable private vehicle according to their group size, luggage, and comfort requirements."
  },
  {
    question: "Can I customize the Ashtavinayak temple route?",
    answer: "Yes, the route and travel schedule can be discussed according to your preferred temple sequence, dates, stay arrangements, and sightseeing requirements."
  },
  {
    question: "How many people can travel in one cab?",
    answer: "Vehicle selection depends on the number of devotees, luggage, and required comfort level. A suitable vehicle can be arranged based on your group size."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, or another preferred location in Pune."
  },
  {
    question: "Can I book the Ashtavinayak cab for multiple days?",
    answer: "Yes, multi-day cab arrangements can be planned when your pilgrimage itinerary requires overnight stays or additional travel time."
  },
  {
    question: "Can other religious places be added to the trip?",
    answer: "Yes, additional religious or sightseeing locations can be discussed while preparing the itinerary, depending on the route and available travel time."
  },
  {
    question: "How can I book a Pune to Ashtavinayak Cab?",
    answer: "Share your travel dates, Pune pickup location, number of devotees, preferred vehicle, expected duration, and pilgrimage requirements with Garud Cab Service to arrange your booking."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Suresh Deshmukh",
    feedback: "Our family planned an Ashtavinayak Darshan from Pune with senior members. Having a private cab made the temple-to-temple travel much easier and allowed us to take breaks when needed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Vaishali Patil",
    feedback: "We arranged an Ashtavinayak pilgrimage for our family group. The vehicle was comfortable and the private travel arrangement gave us flexibility throughout the temple tour.",
    rating: 5
  }
];










  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ashtavinayak Cabs",
  "image": "https://garudcabs.com/assets/images/pune-to-ashtavinayak-cab-service.webp",
  "description": "Book Pune to Ashtavinayak Cabs with Garud Cab for a comfortable and convenient pilgrimage journey. Get reliable Ashtavinayak Darshan cab and car rental services from Pune for complete temple tours, family pilgrimages, and religious trips with Sedan, Ertiga, SUV, Innova, and Innova Crysta vehicles.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-ashtavinayak-cab-service"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune to Ashtavinayak Cabs | Darshan Taxi & Car Rental | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Ashtavinayak Cabs with Garud Cab for a comfortable pilgrimage journey. Get Ashtavinayak Darshan cab, taxi, and car rental services from Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Ashtavinayak Darshan cab Pune, car rental for Ashtavinayak from Pune, cost of Ashtavinayak Yatra tour by car from Pune, Pune to Ashtavinayak cabs, Pune to Ashtavinayak cab service, Pune to Ashtavinayak taxi, Pune to Ashtavinayak taxi service, cab from Pune to Ashtavinayak, taxi from Pune to Ashtavinayak"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/16.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoashtavinayakcabs;